import * as constants from './constants'

export const activateAccount = (accountKey, validationCode) => ({
    type: constants.ACTIVATE_ACCOUNT,
    accountKey,
    validationCode,
})
